import { render } from "./BlockForm.vue?vue&type=template&id=c0ae3438&scoped=true"
import script from "./BlockForm.vue?vue&type=script&lang=js"
export * from "./BlockForm.vue?vue&type=script&lang=js"

import "./BlockForm.vue?vue&type=style&index=0&id=c0ae3438&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ae3438"]])

export default __exports__